module.exports = __webpack_public_path__ + "images/guest-of-honor-b77d1a7dc638e33f99956c99c5db7f2e.png";